export default {
  'recurring.payment.daily': 'Daily',
  'recurring.payment.end': 'End Date',
  'recurring.payment.frequency': 'Frequency',
  'recurring.payment.dateError': 'Unable to set recurring.payment transfer for today',
  'recurring.payment.monthly': 'Monthly',
  'recurring.payment.noEndDate': 'No end date',
  'recurring.payment.repeat': 'Repeat every',
  'recurring.payment.recurrenceAsText': 'recurring.payment Transfer:',
  'recurring.payment.select': 'Select',
  'recurring.payment.selectADate': 'Select a Date',
  'recurring.payment.semimonthly': 'Semi-Monthly',
  'recurring.payment.start': 'Start Date',
  'recurring.payment.title': 'Recurring Payment',
  'recurring.payment.weekly': 'Weekly'
};
